import { BaseAdapter } from "../base.js";
import type { AdapterContext } from "../base.js";
import type { Url } from "../../data-model/primitives.js";
import type { NovelMetadata, ChapterRef, Chapter } from "../../data-model/novel.js";
import { unsafeBrandAdapterId } from "../../data-model/primitives.js";
import { ParseError } from "../../core/errors.js";

const SCAFFOLD_MESSAGE =
  "tangthuvien adapter is a scaffold; full implementation tracked as M5.1 follow-up. " +
  "Site was unreachable at survey time (2026-05-03 Cloudflare interactive Turnstile). " +
  "See docs/surveys/tangthuvien-2026-05-03.md.";

export class TangThuVienAdapter extends BaseAdapter {
  readonly id = unsafeBrandAdapterId("tangthuvien");
  readonly displayName = "TangThuVien";
  readonly hostnames = ["tangthuvien.net", "www.tangthuvien.net"];
  override readonly preferredTransport = "browser" as const;

  override async fetchMetadata(url: Url, _ctx: AdapterContext): Promise<NovelMetadata> {
    throw new ParseError(SCAFFOLD_MESSAGE, { url });
  }

  // eslint-disable-next-line require-yield
  override async *fetchChapterList(url: Url, _ctx: AdapterContext): AsyncIterable<ChapterRef> {
    throw new ParseError(SCAFFOLD_MESSAGE, { url });
  }

  override async fetchChapter(ref: ChapterRef, _ctx: AdapterContext): Promise<Chapter> {
    throw new ParseError(SCAFFOLD_MESSAGE, { url: ref.url });
  }
}
